import { createModel } from '@rematch/core';
import { RootModel } from '../root';

import reducers from './contractAgreements.reducers';
import { AgreementsState } from '../agreements/agreements.model';

export type ContractAgreementsState = Omit<AgreementsState, 'welcomeKISA'>;
const model = createModel<RootModel>()({
  state: {
    agreementsWaitingForContract: [],
    totalDebtAmountOnAllAgreementsByCurrency: {},
    agreements: null,
    agreementsWithProductAvailability: []
  } as ContractAgreementsState,
  reducers
});

export default model;
